import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const EditTestimonialThree = () => {

    const [testimonial, setTestimonial] = useState([]);
    const { id } = useParams();

    useEffect(() => {
        fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/testimonial-three/${id}`)
            .then((res) => res.json())
            .then((info) => setTestimonial(info));
    }, [id]);

    const handleTestimonialSection = (event) => {
        event.preventDefault();
        const imageThree = event.target.imageThree.value;
        const personNameThree = event.target.personNameThree.value;
        const personTitleThree = event.target.personTitleThree.value;
        const descThree = event.target.descThree.value;

        const updatedTestimonial = {
            imageThree,
            personNameThree,
            personTitleThree,
            descThree
        };

        const url = `https://ai-automation-audit-01-e0855711738d.herokuapp.com/testimonial-three/${id}`;
        fetch(url, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(updatedTestimonial),
        })
            .then((res) => res.json())
            .then(() => {
                alert('Testimonial is updated');
            });
    };

    return (
        <>
         
            <div className="container vh-100 d-flex align-items-center justify-content-center">
                <section className="services-area" style={{ width: '100%' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-6 col-md-8">
                                <h3 className="mb-4 text-center">Update Testimonial</h3>

                                <form className="contact-form" onSubmit={handleTestimonialSection}>
                                    <div className="form-group">
                                        <input
                                            className="form-control mb-3"
                                            name="imageThree"
                                            placeholder="imageThree URL"
                                            defaultValue={testimonial.imageThree}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <input
                                            className="form-control mb-3"
                                            name="personNameThree"
                                            placeholder="Person Name"
                                            defaultValue={testimonial.personNameThree}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <input
                                            className="form-control mb-3"
                                            name="personTitleThree"
                                            placeholder="Person Title"
                                            defaultValue={testimonial.personTitleThree}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <input
                                            className="form-control mb-3"
                                            name="descThree"
                                            placeholder="descThreeription"
                                            defaultValue={testimonial.descThree}
                                            required
                                        />
                                    </div>

                                    <div className="text-center">
                                        <button className="theme-btn btn-one">Update Testimonial</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default EditTestimonialThree;
